export enum LeadModalStep {
    APPLICATION_FORM_STANDARD,
    APPLICATION_FORM_WITH_CONVERSATION,
    NOTIFICATION_CONSENT,
    SUCCESS_INFO,
    GOODBYE_INFO,
    MULTILEAD,
    ARCHITECT_OFFER,
    APPLIED_ARCHITECT_OFFER,
    ARCHITECT_MULTILEAD,
    PM_OFFER,
    PM_APPLIED_OFFER,
    PREFERENCES,
    CLOSE,
    WAITING,
    APPLICATION_FORM_FULL_OFFER,
    APPLICATION_FORM_WITH_NEGOTIATION,
    APPLICATION_FORM_WITH_TOPIC
}
export enum LeadModalStep {
    APPLICATION_FORM_STANDARD,
    APPLICATION_FORM_WITH_CONVERSATION,
    NOTIFICATION_CONSENT,
    SUCCESS_INFO,
    GOODBYE_INFO,
    MULTILEAD,
    ARCHITECT_OFFER,
    APPLIED_ARCHITECT_OFFER,
    ARCHITECT_MULTILEAD,
    PM_OFFER,
    PM_APPLIED_OFFER,
    PREFERENCES,
    CLOSE,
    WAITING,
    APPLICATION_FORM_FULL_OFFER,
    APPLICATION_FORM_WITH_NEGOTIATION,
    APPLICATION_FORM_WITH_TOPIC
}
